import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {
        list: [],
        total: 0,
    },
    getters: {},
    actions: {
        async fetch({ state }, {
            page, type, filter, query,
        }) {
            const limit = 10;
            const params = {
                offset: (page - 1) * limit,
                limit,
                filter: { type, ...filter },
                search: query,
            };
            const result = await Sdk.Announcement.PrivateList({ params });
            state.list = result.data.raw;
            state.total = result.data.total;
        },
        create(__, data) {
            const form = new Sdk.FormData(data);
            return Sdk.Announcement.PrivateCreateResource(form);
        },
        update(__, data) {
            const { id, ...payload } = data;
            const form = new Sdk.FormData(payload);
            return Sdk.Announcement.PrivateUpdateResource(id, form);
        },
        delete(__, data) {
            return Sdk.Announcement.PrivateDeleteResource(data.id);
        },
    },
};
